const actions = {
  // Lista de empleados
  GET_EMPLOYEES: 'GET_EMPLOYEES',
  SET_EMPLOYEES: 'SET_EMPLOYEES',
  GET_EMPLOYEES_LOADING: 'GET_EMPLOYEES_LOADING',
  
  // Empleado individual
  GET_EMPLOYEE: 'GET_EMPLOYEE',
  SET_EMPLOYEE: 'SET_EMPLOYEE',
  GET_EMPLOYEE_LOADING: 'GET_EMPLOYEE_LOADING',
  
  // Crear empleado
  CREATE_EMPLOYEE: 'CREATE_EMPLOYEE',
  CREATE_EMPLOYEE_LOADING: 'CREATE_EMPLOYEE_LOADING',
  
  // Actualizar empleado
  UPDATE_EMPLOYEE: 'UPDATE_EMPLOYEE',
  UPDATE_EMPLOYEE_LOADING: 'UPDATE_EMPLOYEE_LOADING',
  
  // Eliminar empleado
  DELETE_EMPLOYEE: 'DELETE_EMPLOYEE',
  DELETE_EMPLOYEE_LOADING: 'DELETE_EMPLOYEE_LOADING',
  
  // Reactivar empleado
  REACTIVATE_EMPLOYEE: 'REACTIVATE_EMPLOYEE',
  REACTIVATE_EMPLOYEE_LOADING: 'REACTIVATE_EMPLOYEE_LOADING',
  
  // Búsqueda
  SEARCH_EMPLOYEES: 'SEARCH_EMPLOYEES',
  SET_SEARCH_RESULTS: 'SET_SEARCH_RESULTS',
  SEARCH_EMPLOYEES_LOADING: 'SEARCH_EMPLOYEES_LOADING',
  
  // Filtros
  SET_EMPLOYEE_FILTERS: 'SET_EMPLOYEE_FILTERS',
  CLEAR_EMPLOYEE_FILTERS: 'CLEAR_EMPLOYEE_FILTERS',
  
  // Rango salarial
  GET_SALARY_RANGE: 'GET_SALARY_RANGE',
  SET_SALARY_RANGE: 'SET_SALARY_RANGE',
  
  // Empleados activos
  GET_ACTIVE_EMPLOYEES: 'GET_ACTIVE_EMPLOYEES',
  SET_ACTIVE_EMPLOYEES: 'SET_ACTIVE_EMPLOYEES',
  
  // Empleados por sucursal
  GET_EMPLOYEES_BY_BRANCH: 'GET_EMPLOYEES_BY_BRANCH',
  SET_EMPLOYEES_BY_BRANCH: 'SET_EMPLOYEES_BY_BRANCH',
  
  // Empleados por puesto
  GET_EMPLOYEES_BY_POSITION: 'GET_EMPLOYEES_BY_POSITION',
  SET_EMPLOYEES_BY_POSITION: 'SET_EMPLOYEES_BY_POSITION',
  
  // Limpiar estado
  CLEAR_EMPLOYEES: 'CLEAR_EMPLOYEES',
  CLEAR_EMPLOYEE: 'CLEAR_EMPLOYEE',
  
  // Actions
  getEmployees: (filters?: any) => ({
    type: actions.GET_EMPLOYEES,
    filters
  }),
  
  setEmployees: (data: any) => ({
    type: actions.SET_EMPLOYEES,
    data
  }),
  
  getEmployeesLoading: (loading: boolean) => ({
    type: actions.GET_EMPLOYEES_LOADING,
    loading
  }),
  
  getEmployee: (id: string) => ({
    type: actions.GET_EMPLOYEE,
    id
  }),
  
  setEmployee: (data: any) => ({
    type: actions.SET_EMPLOYEE,
    data
  }),
  
  getEmployeeLoading: (loading: boolean) => ({
    type: actions.GET_EMPLOYEE_LOADING,
    loading
  }),
  
  createEmployee: (employeeData: any) => ({
    type: actions.CREATE_EMPLOYEE,
    employeeData
  }),
  
  createEmployeeLoading: (loading: boolean) => ({
    type: actions.CREATE_EMPLOYEE_LOADING,
    loading
  }),
  
  updateEmployee: (id: string, employeeData: any) => ({
    type: actions.UPDATE_EMPLOYEE,
    id,
    employeeData
  }),
  
  updateEmployeeLoading: (loading: boolean) => ({
    type: actions.UPDATE_EMPLOYEE_LOADING,
    loading
  }),
  
  deleteEmployee: (id: string) => ({
    type: actions.DELETE_EMPLOYEE,
    id
  }),
  
  deleteEmployeeLoading: (loading: boolean) => ({
    type: actions.DELETE_EMPLOYEE_LOADING,
    loading
  }),
  
  reactivateEmployee: (id: string) => ({
    type: actions.REACTIVATE_EMPLOYEE,
    id
  }),
  
  reactivateEmployeeLoading: (loading: boolean) => ({
    type: actions.REACTIVATE_EMPLOYEE_LOADING,
    loading
  }),
  
  searchEmployees: (query: string, filters?: any) => ({
    type: actions.SEARCH_EMPLOYEES,
    query,
    filters
  }),
  
  setSearchResults: (data: any) => ({
    type: actions.SET_SEARCH_RESULTS,
    data
  }),
  
  searchEmployeesLoading: (loading: boolean) => ({
    type: actions.SEARCH_EMPLOYEES_LOADING,
    loading
  }),
  
  setEmployeeFilters: (filters: any) => ({
    type: actions.SET_EMPLOYEE_FILTERS,
    filters
  }),
  
  clearEmployeeFilters: () => ({
    type: actions.CLEAR_EMPLOYEE_FILTERS
  }),
  
  getSalaryRange: () => ({
    type: actions.GET_SALARY_RANGE
  }),
  
  setSalaryRange: (data: any) => ({
    type: actions.SET_SALARY_RANGE,
    data
  }),
  
  getActiveEmployees: (filters?: any) => ({
    type: actions.GET_ACTIVE_EMPLOYEES,
    filters
  }),
  
  setActiveEmployees: (data: any) => ({
    type: actions.SET_ACTIVE_EMPLOYEES,
    data
  }),
  
  getEmployeesByBranch: (branchId: string) => ({
    type: actions.GET_EMPLOYEES_BY_BRANCH,
    branchId
  }),
  
  setEmployeesByBranch: (data: any) => ({
    type: actions.SET_EMPLOYEES_BY_BRANCH,
    data
  }),
  
  getEmployeesByPosition: (position: string) => ({
    type: actions.GET_EMPLOYEES_BY_POSITION,
    position
  }),
  
  setEmployeesByPosition: (data: any) => ({
    type: actions.SET_EMPLOYEES_BY_POSITION,
    data
  }),
  
  clearEmployees: () => ({
    type: actions.CLEAR_EMPLOYEES
  }),
  
  clearEmployee: () => ({
    type: actions.CLEAR_EMPLOYEE
  })
};

export default actions;
